import {Component, OnInit, Input, PLATFORM_ID, Inject, ViewChild} from '@angular/core';
import {saveAs as importedSaveAs} from "file-saver";
import {AccountService} from "../account.service";
import {isPlatformBrowser, DatePipe} from "@angular/common";
import {ContactFormModalComponent} from "../../contact-form-modal/contact-form-modal.component";

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css']
})

export class TicketsComponent implements OnInit {
  today:any;
  viewdetail:any=0;
  @Input() user;
  tikets:any;
  orders:any;
  qrcode:any;
  ticket:any=[];
  order:any;
  downloaderror:any;
  downloadsucces:any;
  resenderror:any;
  resendsucces:any;
  loading:any;
  editmode:any=false;
  updatesucces:any=false;
  updateerror:any=false;
  k:any=0;
  j:any=0;
  @ViewChild('contactFormModal') contactFormModal:ContactFormModalComponent;
  constructor(private accountservice:AccountService,@Inject(PLATFORM_ID) private platformId: Object,private datePipe: DatePipe) {
   /* accountservice.tickets().then( res => {
      this.tikets = this.filtrer(res)

      console.log(this.tikets)
    });

*/
   this.loadOrders();
  }

  loadOrders() {
    this.accountservice.orders().then( res => {
      //console.log(res)
      this.orders = this.filtrerOrders(res)
      this.calculatenumbers(this.filtrerOrders(res))
    });
  }

  openContactModal(order) {
    //console.log(order)
    if(order.event.user.organisation) {
      this.contactFormModal.orgaMail = order.event.user.organisation.email
      this.contactFormModal.showModal();
    }
    else {
      alert('l\'organisateur n\'a pas renseigner ces infos');
    }
  }



  filtrerOrders(orders) {
    /* tickets[i].order.state==1*/
    let tmp=[];
    for( let i=0;i<orders.length;i++) {
      if(orders[i].event && orders[i].state) {
        tmp.push(orders[i]);
      }
    }
    return tmp;
  }



  filtrer(tickets) {
   /* tickets[i].order.state==1*/
    let tmp=[];
    for( let i=0;i<tickets.length;i++) {
      if((tickets[i].order_id && tickets[i].order && !tickets[i].statut)  || new Date(tickets[i].created_at) <= new Date('2018-06-12') && !tickets[i].statut) {
        tmp.push(tickets[i]);
      }
    }
    return tmp;
  }

  calculatenumbers(tmp) {
    for( let i=0;i<tmp.length;i++) {

      if (tmp[i].event && tmp[i].event.end_date >= (this.datePipe.transform(new Date(), "yyyy-MM-dd"))) {
        this.k++;
      }

      if (tmp[i].event && tmp[i].event.end_date < (this.datePipe.transform(new Date(), "yyyy-MM-dd"))) {
        this.j++;
      }

    }

   // console.log('j ='+this.j);
  }


  ngOnInit() {

    let $ = window['jQuery'];
    this.today = new Date();
    if (isPlatformBrowser(this.platformId)) {
      try {
        $(document).ready(function(){
          $('ul.tabs li').click(function(){
            var tab_id = $(this).attr('data-tab');

            $('ul.tabs li').removeClass('current');
            $('.tab-content').removeClass('current');

            $(this).addClass('current');
            $("#"+tab_id).addClass('current');
          })

        })

      } catch (e) {
        console.log("not in browser");
      }
    }
  }

  getQrCode(id) {
    return this.accountservice.qrcode(id).then(res=> {
      //console.log(res)
      return res;
    })
  }


  detail(e,id): Promise<any> {

    this.accountservice.ticket(id).then(res=> {
      let me = this;
      me.ticket = res;
      this.getQrCode(id).then(
        res =>  {
          this.ticket.qrcode = res;
          this.viewdetail = 1;
        }
      );

     // console.log(res);
    });
    return;
  }

  download(e,id):Promise<any> {
    e.preventDefault();
    this.clean();
    this.loading=true;
    console.log('generation ...')

    window.scrollTo(0,0);
    this.accountservice.downloadpdf(id).then(res => {
          this.clean();
          this.downloadsucces=true;
        let blob = new Blob([res], {type: 'application/pdf'});
        //console.log(blob);
        this.accountservice.geTicketName(id).then(res =>
          importedSaveAs(blob, res)
        )
      })
      .catch(error => {
        console.log(error);
        this.clean();
        this.downloaderror=true;
      });

    return;
  }

  resend(e,id):Promise<any> {
    e.preventDefault();
    this.clean();
    this.loading = true;
    console.log('resending...')
    window.scrollTo(0,0);
    this.accountservice.resendMail(id).then(res => {
      this.clean()
      this.resendsucces = true;
        console.log(res);
      }
    ).catch(error => {
          this.clean();
          this.resenderror = true;
          console.log(error)
        }
      );
    return;
  }

  replaceTicketsInDom(){
    for(let i=0;i<this.order.tickets.length;i++) {
      if(this.order.tickets[i].id == this.ticket.id){
        this.order.tickets[i] = this.ticket;
        return;
      }
    }
  }

  update(e):Promise<any> {
       //console.log('ok');
       e.preventDefault();
        this.clean();
        this.loading = true;
        this.accountservice.update(this.ticket.id,this.ticket).then(res => {
        //this.loadOrders();
        this.replaceTicketsInDom()
        this.clean();
        this.updatesucces = true;
        this.viewdetail = 2;
        console.log(res);
      }
    ).catch(error => {
           this.clean();
          this.updateerror = true;
          console.log(error)
        }
      );
    return;
  }


  tickets(): Promise<any> {
       this.viewdetail = 0;
       this.clean();

    if (isPlatformBrowser(this.platformId)) {
      let $ = window['jQuery'];
      try {
        $(document).ready(function(){

          $('ul.tabs li').click(function(){
            var tab_id = $(this).attr('data-tab');

            $('ul.tabs li').removeClass('current');
            $('.tab-content').removeClass('current');

            $(this).addClass('current');
            $("#"+tab_id).addClass('current');
          })
        })
      } catch (e) {
        console.log("not in browser");
      }
    }
       return;
  }

  eventIsOnline(event) {
    return event.onlineLocationChoice === 'evenemet_en_ligne';
  }

 location(order) {
    if(order.event.onlineLocationChoice === 'evenemet_en_ligne')
      return order.event.onlineLink;
   return order.event.location_name+'-'+order.event.zipcode+''+order.event.city
 }

 addOrderTicketQrcode(order) {

   for(let i=0; i<order.tickets.length; i++) {
     this.getQrCode(order.tickets[i].id).then(
       res =>  order.tickets[i].qrcode = res
     );
   }
   return order
 }

  detailComande(e,order) {

  }

  showtickets(e,order) {
    console.log(order)
    e.preventDefault();
   // console.log(this.addOrderTicketQrcode(order));
    this.order = this.addOrderTicketQrcode(order);
    this.viewdetail = 2;

    return;
  }

  clean(){
    this.updateerror = false;
    this.updatesucces = false;
    this.resendsucces = false;
    this.resenderror = false;
    this.downloadsucces = false;
    this.downloaderror = false;
    this.loading = false;
  }

  allDeadlineIsPaind(deadlines) {
    for(let i=0;i<deadlines.length;i++) {
      if(!deadlines[i].payed) {
        return false;
      }
    }
    return true;
  }

  orderIsPaid(order) {
    return order.state  && order.deadlines.length == 0 || order.state && this.allDeadlineIsPaind(order.deadlines)
  }

}
